module.exports = __webpack_public_path__ + "static/p-contact2-180f76f4a38b3792b3692aeb1d0f314f.png";